import { ReactComponent as DayPreviewIcon } from "assets/svg/day-preview.svg";
import { ReactComponent as MenuHamburgerIcon } from "assets/svg/menu-hamburger.svg";
import { ReactComponent as OutlineChevronLeft } from "assets/svg/outline-chevron-left.svg";
import { ReactComponent as OutlineChevronRight } from "assets/svg/outline-chevron-right.svg";
import { ReactComponent as OutlinePlusIcon } from "assets/svg/outline-plus.svg";
import { ReactComponent as OutlineSearchIcon } from "assets/svg/outline-search.svg";
import IconButton from "components/icon-button";
import moment from "moment-timezone";
import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  showAddToCalendar,
  showMobileSidebar,
} from "store/calendarSidebarSlice";
import { AmplitudePageName, track } from "utils/amplitude";
import { useCalendarTime } from "../../../../contexts/CalendarTimeContext";
import { getDefaultSessionDateTime } from "../create-session/utils/getDefaultSessionDateTime";
import styles from "./CalendarHeaderMobile.module.scss";

const ANALYTICS_PAGE_NAME: AmplitudePageName = "pro-calendar";

const CalendarHeaderMobile = () => {
  const dispatch = useDispatch();

  const { setAnchorTime, currentCalendarTimezone, onChangeTimeRange } =
    useCalendarTime();

  const todayValue = useMemo(
    () => moment().tz(currentCalendarTimezone).startOf("day").valueOf(),
    [currentCalendarTimezone],
  );

  const onShowSidebarClick = useCallback(
    () => dispatch(showMobileSidebar()),
    [dispatch],
  );

  const onAddToCalendarClick = useCallback(() => {
    dispatch(
      showAddToCalendar({
        hasInitialTime: true,
        defaultStartTime: getDefaultSessionDateTime(
          currentCalendarTimezone,
        ).valueOf(),
      }),
    );
  }, [currentCalendarTimezone, dispatch]);

  return (
    <div className={styles.container}>
      <div className={styles["left-content"]}>
        <IconButton onClick={onShowSidebarClick}>
          <MenuHamburgerIcon />
        </IconButton>
        <button
          className={styles["today-button"]}
          onClick={() => {
            track(ANALYTICS_PAGE_NAME, "today-button", "click");
            setAnchorTime && setAnchorTime(todayValue);
          }}
        >
          {"Today"}
        </button>
        {/* TODO: Remove the buttons below when they are no longer needed */}
        <IconButton
          onClick={() => {
            track(ANALYTICS_PAGE_NAME, "time-range-left-arrow", "click");
            onChangeTimeRange(-1);
          }}
        >
          <OutlineChevronLeft />
        </IconButton>
        <IconButton
          onClick={() => {
            track(ANALYTICS_PAGE_NAME, "time-range-right-arrow", "click");
            onChangeTimeRange(1);
          }}
        >
          <OutlineChevronRight />
        </IconButton>
      </div>
      <div className={styles["right-content"]}>
        {false && (
          // TODO: Show these items when their features are ready
          <>
            <IconButton>
              <DayPreviewIcon />
            </IconButton>
            <IconButton>
              <OutlineSearchIcon />
            </IconButton>
          </>
        )}
        <IconButton onClick={onAddToCalendarClick}>
          <OutlinePlusIcon className={styles["add-to-calendar-button"]} />
        </IconButton>
      </div>
    </div>
  );
};

export default CalendarHeaderMobile;
